<aims-side-menu [component]="permissions.ComponentID.Management">
  <ng-template>
    <aims-side-menu-link [route]="'/management'"
                         [iconClass]="'fas fa-list-ol'"> 
      Management Dashboard
    </aims-side-menu-link>
    <aims-side-menu-link [route]="'./copas'"
                         [iconClass]="'fas fa-list'">
      COPAs
    </aims-side-menu-link>
  </ng-template>
</aims-side-menu>
